import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import Slide from '@material-ui/core/Slide';
import { getWebSocket } from './websocket';
import Progress from './ui/react-ui/progress.jsx'; // import GoogleMap from './ui/google-map'

import ITSMap from './ui/ITS-map.js';
import Tabs from './ui/react-ui/tabs';
import InformationFilter from './trafficLive/informationFilter';
import MyFavorite from './trafficLive/myFavorite';
import ForecastPassingTime from './trafficLive/forecastPassingTime';
import TvWallCart from './trafficLive/tvWallCart';
import TrafficLiveDialog from './trafficLive/trafficLive-dialog';
import { setMapMarkerList, setFavoriteCameras, reset } from '../redux/traffic-live';
import { setOpenTrafficLiveTab } from '../redux/app'; // get api

import { getAreaGatesGeographic, getAreaTerminalsGeographic } from '../api/areaAPI';
import { getDeviceCamerasgeographic, getEventTrafficGeographic, getVdsGeographic, getDeviceCamerasFavorite } from '../api/deviceAPI';
var t = i18n.getFixedT(null, 'traffic-live');
var TrafficLive = /*#__PURE__*/React.memo(function (props) {
  // redux
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      rights = _useSelector.sessionObj.rights,
      _useSelector$envCfg = _useSelector.envCfg,
      contextRoot = _useSelector$envCfg.contextRoot,
      isManagementMode = _useSelector$envCfg.isManagementMode,
      _useSelector$trafficL = _useSelector.trafficLive,
      mapBounds = _useSelector$trafficL.mapBounds,
      mapMarkerList = _useSelector$trafficL.mapMarkerList,
      openTrafficLiveTab = _useSelector.app.openTrafficLiveTab;

  var id = props.id;

  var _useState = useState('informationFilter'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTabs = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      terminalNoteList = _useState4[0],
      setTerminalNoteList = _useState4[1]; // const [ isShowTab, setIsShowTab ] = useState(true)


  var _isMounted = useRef();

  var _socket = useRef();

  var _currentMarkers = useRef(0);

  var tabsMenu = [{
    key: 'informationFilter',
    title: t('lbl-information-filter')
  }];

  if (_.includes(rights, isManagementMode ? 'evms.map.favorite' : 'web.map.favorite')) {
    tabsMenu.push({
      key: 'myFavorite',
      title: t('lbl-my-favorite')
    });
  }

  if (_.includes(rights, isManagementMode ? 'evms.map.prediction' : 'web.map.prediction')) {
    tabsMenu.push({
      key: 'forecastPassingTime',
      title: t('lbl-forecastPassingTime')
    });
  }

  var markerTypes = [{
    dataType: 'camera',
    label: t('lbl-live'),
    icon: 'camera',
    iconUrl: '/images/icon/icon-camera-select.png'
  }, {
    dataType: 'roads-event',
    label: t('lbl-roads-event'),
    icon: 'alert',
    iconUrl: '/images/icon/icon-alert-select.png'
  }, {
    dataType: 'live-traffic',
    label: t('lbl-live-traffic'),
    icon: 'car',
    iconUrl: '/images/icon/icon-car-select.png'
  }, {
    dataType: 'terminal-station',
    label: t('lbl-terminal-station'),
    icon: 'terminal',
    iconUrl: '/images/icon/icon-terminal-select.png'
  }, {
    dataType: 'gate-station',
    label: t('lbl-gate-station'),
    icon: 'gate',
    iconUrl: '/images/icon/icon-gate-select.png'
  }];

  var handleAlarmEventData = function handleAlarmEventData(data) {
    var newMarkers = _.cloneDeep(_currentMarkers.current);

    var isRemove = _.find(_currentMarkers.current, function (el) {
      return el.id === data.id;
    });

    if (isRemove) _.remove(newMarkers, function (el) {
      return el.id === data.id;
    });else newMarkers.push(_objectSpread(_objectSpread({}, data), {}, {
      dataType: 'roads-event'
    }));
    _currentMarkers.current = newMarkers;
    dispatch(setMapMarkerList(newMarkers));
  };

  useEffect(function () {
    if (_isMounted.current && !_.isEmpty(mapBounds)) {
      // Progress.startSpin()
      var latLngStart = mapBounds._southWest,
          latLngEnd = mapBounds._northEast;
      var areaGates = getAreaGatesGeographic(contextRoot, true, latLngStart, latLngEnd);
      var areaTerminals = getAreaTerminalsGeographic(contextRoot, true, latLngStart, latLngEnd);
      var deviceCameras = getDeviceCamerasgeographic(contextRoot, true, latLngStart, latLngEnd);
      var eventTraffic = getEventTrafficGeographic(contextRoot, true, latLngStart, latLngEnd);
      var vds = getVdsGeographic(contextRoot, true, latLngStart, latLngEnd);
      $.when(areaGates, areaTerminals, deviceCameras, eventTraffic, vds).then(function (areaGates_result, areaTerminals_result, deviceCameras_result, eventTraffic_result, vds_result) {
        var markers = [],
            newTerminalNoteList = [];

        var markers_gates = _.map(areaGates_result.content, function (el) {
          return _objectSpread({
            dataType: 'gate-station'
          }, el);
        });

        var markers_terminals = _.map(areaTerminals_result.content, function (el) {
          newTerminalNoteList.push({
            id: el.id,
            inferLineNote: el.inferLineNote ? el.inferLineNote : null,
            inferWorkDurationSecs: el.inferWorkDurationSecs ? el.inferWorkDurationSecs : null
          });
          return _objectSpread({
            dataType: 'terminal-station'
          }, el);
        });

        var markers_camreas = _.map(deviceCameras_result.content, function (el) {
          return _objectSpread({
            dataType: 'camera'
          }, el);
        });

        var markers_eventTraffic = _.map(eventTraffic_result.content, function (el) {
          return _objectSpread({
            dataType: 'roads-event'
          }, el);
        });

        var markers_vds = _.map(vds_result.content, function (el) {
          return _objectSpread({
            dataType: 'live-traffic'
          }, el);
        });

        markers = [].concat(_toConsumableArray(markers_gates), _toConsumableArray(markers_terminals), _toConsumableArray(markers_camreas), _toConsumableArray(markers_eventTraffic), _toConsumableArray(markers_vds));
        _currentMarkers.current = markers;
        dispatch(setMapMarkerList(markers));
        setTerminalNoteList(_.keyBy(newTerminalNoteList, 'id')); // Progress.done()
      }).catch(function (error) {
        console.log(error); // Progress.done()
      });
    }
  }, [JSON.stringify(mapBounds)]);
  useEffect(function () {
    if (!_isMounted.current) {
      _isMounted.current = true;
      getDeviceCamerasFavorite(contextRoot, false).then(function (result) {
        dispatch(setFavoriteCameras(result.content));
      });
      _socket.current = getWebSocket();

      _socket.current.on('event', handleAlarmEventData);
    }

    return function () {
      dispatch(reset());

      _socket.current.off('event');
    };
  }, []);

  var renderTabsContent = function renderTabsContent() {
    switch (currentTab) {
      case 'informationFilter':
        return /*#__PURE__*/React.createElement(InformationFilter, {
          markerTypes: markerTypes
        });

      case 'myFavorite':
        return /*#__PURE__*/React.createElement(MyFavorite, null);

      case 'forecastPassingTime':
        return /*#__PURE__*/React.createElement(ForecastPassingTime, null);

      default:
        return /*#__PURE__*/React.createElement("div", null, "test");
    }
  };

  var handleOpenTab = function handleOpenTab() {
    dispatch(setOpenTrafficLiveTab(!openTrafficLiveTab));
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", null, !openTrafficLiveTab && /*#__PURE__*/React.createElement("div", {
    className: cx('slide-icon', 'close'),
    onClick: handleOpenTab
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, null)), /*#__PURE__*/React.createElement(Slide, {
    direction: "left",
    in: openTrafficLiveTab,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slide-icon",
    onClick: handleOpenTab
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null)), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-traffic-live-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTabs(key);
    }
  }, renderTabsContent())))), /*#__PURE__*/React.createElement(ITSMap, {
    markerTypes: JSON.stringify(markerTypes)
  }), /*#__PURE__*/React.createElement(TvWallCart, null), /*#__PURE__*/React.createElement(TrafficLiveDialog, {
    markerTypes: JSON.stringify(markerTypes),
    terminalNoteList: terminalNoteList
  }));
});
TrafficLive.defaultProps = {
  id: 'g-traffic-live'
};
TrafficLive.PropTypes = {};
export default TrafficLive;